<template>
  <select
    v-model="model"
    class="form-select"
    :class="{
      'is-invalid': hasError,
    }"
  >
    <option selected disabled value="">{{ placeholder }}</option>
    <option v-if="showDefaultEmptyValue" value="">Todos</option>
    <option
      v-for="option of options"
      :value="option.value"
      :selected="option.selected"
    >
      {{ option.label }}
    </option>
  </select>
</template>

<script lang="ts" setup>
import { SelectOption } from "@/@types";

type SelectProps = {
  hasError?: boolean;
  placeholder?: string;
  options: SelectOption[];
  showDefaultEmptyValue?: boolean;
};

const emit = defineEmits(["update:modelValue"]);
const model = defineModel<string>();

const {
  hasError = false,
  options = [],
  placeholder = "Selecione",
} = defineProps<SelectProps>();
</script>
